/* SPDX-License-Identifier: AGPL-3.0-or-later */

import { Component, inject, input, OnInit } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { BeerPongTableEndpointService } from 'openapi-generated';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpErrorResponse } from '@angular/common/http';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'beer-pong-table-update',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
  ],
  providers: [],
  templateUrl: './beer-pong-table-update.component.html',
  styleUrl: './beer-pong-table-update.component.scss',
})
export class BeerPongTableUpdateComponent implements OnInit {
  beerPongTableForm = new FormGroup({
    name: new FormControl('', [
      Validators.required,
      Validators.minLength(3),
      Validators.maxLength(20),
      Validators.pattern(/^[\w\s.äÄöÖüÜ\-,#]*$/),
    ]),
  });

  client = inject(BeerPongTableEndpointService);
  router = inject(Router);
  route = inject(ActivatedRoute);
  snackBar = inject(MatSnackBar);

  beerPongTableId = input<number>();

  ngOnInit() {
    this.loadBeerPongTable();
  }

  private loadBeerPongTable() {
    if (this.beerPongTableId() !== undefined) {
      this.client.getBeerPongTable(this.beerPongTableId()!).subscribe({
        next: data => {
          this.beerPongTableForm.setValue({ name: data.name ?? '' });
        },
        error: () => {
          this.snackBar.open('Failed to load beer pong table', 'Close', { duration: 3000 });
        },
      });
    }
  }

  saveBeerPongTable() {
    this.beerPongTableForm.disable();

    this.route.params.subscribe(params =>
      this.client
        .updateBeerPongTable(params.beerPongTableId, {
          name: this.beerPongTableForm.controls.name.value ?? '',
        })
        .subscribe({
          next: () => {
            this.snackBar.open('Successfully updated beer pong table', 'Close', {
              duration: 3000,
            });
            this.router.navigate(['../..'], { relativeTo: this.route });
          },
          error: async (er: HttpErrorResponse) => {
            this.snackBar.open(
              typeof er.error === 'string'
                ? er.error
                : `There was a problem creating the beer pong table: ${await er.error.text()}`,
              'Close',
              { duration: 3000 },
            );
            this.beerPongTableForm.enable();
          },
        }),
    );
  }

  updateBeerPongTable() {
    if (this.beerPongTableForm.valid) {
      this.saveBeerPongTable();
    }
  }
}
